import clsx from 'clsx';

type Tone = 'neutral' | 'brand' | 'accent' | 'contrast' | 'muted';
type Surface = 'solid' | 'soft' | 'transparent';

interface Options {
  tone?: Tone;
  surface?: Surface;
  invert?: boolean;
}

const toneStyles: Record<Tone, { solid: string; soft: string; text: string }> = {
  neutral: {
    solid: 'bg-background text-foreground',
    soft: 'bg-muted text-foreground',
    text: 'text-foreground',
  },
  brand: {
    solid: 'bg-primary text-primary-foreground',
    soft: 'bg-primary/10 text-primary',
    text: 'text-primary',
  },
  accent: {
    solid: 'bg-accent text-accent-foreground',
    soft: 'bg-accent/10 text-accent',
    text: 'text-accent',
  },
  contrast: {
    solid: 'bg-foreground text-background',
    soft: 'bg-foreground/10 text-foreground',
    text: 'text-foreground',
  },
  muted: {
    solid: 'bg-muted text-muted-foreground',
    soft: 'bg-muted text-muted-foreground',
    text: 'text-muted-foreground',
  },
};

export function getSurfaceStyles({ tone = 'neutral', surface = 'solid', invert }: Options) {
  if (invert) {
    return {
      className: clsx('bg-foreground text-background'),
      dataAttrs: { 'data-tone': tone, 'data-surface': surface, 'data-invert': '' },
    };
  }
  const t = toneStyles[tone];
  let classes = '';
  switch (surface) {
    case 'soft':
      classes = t.soft;
      break;
    case 'transparent':
      classes = clsx('bg-transparent', t.text);
      break;
    default:
      classes = t.solid;
  }
  return { className: classes, dataAttrs: { 'data-tone': tone, 'data-surface': surface } };
}
